module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.pedido), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'show-purchase-order',
          params: {
            id: data.id
          },
        }
      }
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.id))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.product_info))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("F. compra: "), _c('br'), _vm._v(" " + _vm._s(data.attributes.order_create_date) + " "), _c('br'), _vm._v(" F. entrega: "), _c('br'), _vm._v(_vm._s(data.attributes.promised_delivery_date))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("Pago: "), _c('br'), _vm._v(" Pendiente "), _c('br'), _vm._v(" Tracking: "), _c('br'), _vm._v(" Pendientes")])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.currency) + "\n                  " + _vm._s((data.attributes.total_cost * data.attributes.exchange).toFixed(2)))])])])])], 1)
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e3269fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/PedidoComponent.vue
// module id = 1905
// module chunks = 1